import React from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
        <div className="modal-header">
          <h3>{title || t('confirmDialog.defaultTitle')}</h3>
        </div>
        <div className="modal-body">
          <p>{message || t('confirmDialog.defaultMsg')}</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            {t('confirmDialog.cancelBtn')}
          </button>
          <button className="btn btn-danger" onClick={onConfirm}>
            {t('confirmDialog.confirmBtn')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
